import React, { useEffect, useState } from "react";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import { useAdminContext } from "../../Hooks/AdminContext";
import CustomTable from "../../components/customTable/CustomTable";
import { IconButton, Modal } from "@mui/material";
import moment from "moment";
import Iconify from "../../components/Iconify";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import { Box } from "@mui/system";
import { _CC_Auth_List } from "../../DAL/Listing/CCAuthorization";
import { picBaseUrl } from "../../config/config";

export const AuthorizationCC = () => {
  const { setnavbarTitle } = useAdminContext();
  const [AuthList, SetAuthList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [openViewer, setOpenViewer] = useState(false);
  const [docUrl, setDocUrl] = useState("");

  // `handleViewDoc` is a function that sets the document URL and opens the document viewer.
  const handleViewDoc = (url) => {
    setDocUrl(url);
    setOpenViewer(true);
  };

  // `searchFunction` handles the search input, updates the local storage with the search query, resets the page, and fetches the filtered data.
  const searchFunction = (e) => {
    e.preventDefault();
    localStorage.setItem("searchText_CC_Authorization_Page", searchText);
    setPage(0);
    GetAuthList(0, rowsPerPage, searchText);
  };

  // Handles changing the current page in pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // Handles changing the number of rows displayed per page in pagination
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handles page change and adjusts the page count in pagination
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const handleAgreeDelete = () => {};

  // Fetches the list of credit card authorizations with pagination and search functionality
  const GetAuthList = async (pages, rows, searchText) => {
    setIsLoading(true);
    const formData = {
      search: searchText,
    };
    const response = await _CC_Auth_List(formData, pages, rows);
    const { total_count, total_pages, cc_authorization_list } = response;
    if (response.code === 200) {
      setTotalCount(total_count);
      setTotalPages(total_pages);
      SetAuthList(cc_authorization_list);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  // This is the column configuration for the user table
  // Each column has an id, a label to display, and a renderData function
  // The renderData function customizes how each column's data is displayed
  const User_Table_Head = [
    // {
    //   id: "action",
    //   label: "Action",
    //   renderData: (row) => (
    //     <Tooltip title="Delete" placement="top">
    //       <DeleteOutlineIcon
    //         onClick={() => {
    //           handleAgreeDelete(row);
    //         }}
    //         style={{
    //           fill: "#ff0000",
    //           marginRight: "10px",
    //           cursor: "pointer",
    //         }}
    //       />
    //     </Tooltip>
    //   ),
    // },
    {
      id: "number",
      label: "Sr#",
      type: "number",
    },
    {
      id: "user_name",
      label: "User",
      renderData: (row) => {
        const fullName =
          row?.user_info?.first_name && row?.user_info?.last_name
            ? `${row.user_info.first_name} ${row.user_info.last_name}`
            : "_ _";

        const email = row?.user_info?.email || "_ _";

        return (
          <div>
            <div>{fullName}</div>
            <div className="text-muted" style={{ fontSize: "0.9em" }}>
              {email}
            </div>
          </div>
        );
      },
    },
    {
      id: "credit_card",
      label: "Credit Card Number",
      renderData: (row) =>
        row?.card_number ? `**** **** **** ${row.card_number}` : "_ _",
    },
    {
      id: "createdAt",
      label: "Created At",
      renderData: (row) => {
        return moment(row.createdAt).format("DD MMM YY hh:mm A");
      },
    },
    {
      id: "file",
      label: "File",
      renderData: (row) => {
        if (
          row?.authorization_form_url &&
          row.authorization_form_url.toLowerCase().endsWith(".pdf")
        ) {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* PDF Icon */}
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Iconify
                  icon="vscode-icons:file-type-pdf2"
                  style={{
                    fontSize: "60px",
                    color: "#6D00FC",
                  }}
                />
              </div>

              {/* Icon Buttons */}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "0px" }}
              >
                {/* View in Modal */}
                <span
                  title="View"
                  style={{
                    color: "#007bff",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleViewDoc(picBaseUrl + row.authorization_form_url)
                  }
                >
                  <Iconify icon="mdi:eye-outline" />
                </span>

                {/* Download File */}
                <a
                  href={picBaseUrl + row.authorization_form_url}
                  download
                  title="Download"
                  style={{ color: "#28a745", fontSize: "24px" }}
                >
                  <Iconify icon="mdi:download-outline" />
                </a>
              </div>
            </div>
          );
        }
        return "_ _";
      },
    },
  ];

  // useEffect hook for handling CC Authorization page initialization and API call
  useEffect(() => {
    setnavbarTitle("CC Authorization");
    const searchText = localStorage.getItem("searchText_CC_Authorization_Page");
    if (searchText) {
      setSearchText(searchText);
      GetAuthList(page, rowsPerPage, searchText);
    } else {
      GetAuthList(page, rowsPerPage, "");
    }
    // eslint-disable-next-line
  }, [rowsPerPage, page]);

  if (isLoading) {
    return <CustomCircularProgress />;
  }
  return (
    <div className="row mt-4">
      <Modal
        open={openViewer}
        onClose={() => setOpenViewer(false)}
        aria-labelledby="pdf-viewer"
        aria-describedby="Shows the PDF document"
      >
        <Box
          sx={{
            width: "80%",
            height: "90vh",
            margin: "5vh auto",
            backgroundColor: "#121212",
            padding: "40px",
            outline: "none",
            overflow: "hidden",
            borderRadius: "8px",
            position: "relative",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={() => setOpenViewer(false)}
            sx={{
              position: "absolute",
              top: "3px",
              right: "3px",
              zIndex: 10,
              color: "white",
            }}
          >
            <Iconify icon="ic:round-close" width={24} height={24} />
          </IconButton>

          {/* Scrollable Content */}
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
            }}
          >
            <DocViewer
              documents={[{ uri: docUrl, fileType: "pdf" }]}
              pluginRenderers={DocViewerRenderers}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: false,
                },
              }}
            />
          </Box>
        </Box>
      </Modal>

      <CustomTable
        data={AuthList}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={[]}
        custom_search={{
          searchText: searchText,
          setSearchText: setSearchText,
          handleSubmit: searchFunction,
        }}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        pagePagination={true}
        handleChangePages={handleChangePages}
        placeHoldertext="Search by name or email"
      />
    </div>
  );
};
